import { GOOGLE_PLAY_DOWNLOAD_COUNT } from 'constants/values';

import { translate } from 'helpers/utils';

import socialProof from 'assets/img/draws/socialProof2.webp';

interface IObSocialProofContent {
    count: string | number;
    imgData: string;
    buttonData: {
        text: string;
        fixed: boolean;
        dataLocator: string;
    };
    translateKey: string;
}

export const getContent = (): IObSocialProofContent => {
    return {
        count: GOOGLE_PLAY_DOWNLOAD_COUNT,
        imgData: socialProof,
        buttonData: {
            text: translate('Continue'),
            fixed: true,
            dataLocator: 'obNextStep',
        },
        translateKey: 'socialProofTitleNew2',
    };
};
